import { render } from "./MovePage.vue?vue&type=template&id=60096094&scoped=true"
import script from "./MovePage.vue?vue&type=script&lang=js"
export * from "./MovePage.vue?vue&type=script&lang=js"

import "./MovePage.vue?vue&type=style&index=0&id=60096094&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60096094"]])

export default __exports__